import type { Driveway } from "building-types/driveways/drivewayTypes";
import type { ExteriorMaterialOverride } from "building-types/materials/materialTypes";
import { buildingEntityBaseNew } from "doc/utils/buildingEntityTools";
import GeomTagGroup from "geom/geomTagGroup";

export function drivewayNew(): Driveway {
  return {
    ...buildingEntityBaseNew("DRIVEWAY"),
    exterior: new GeomTagGroup<ExteriorMaterialOverride>(),
  };
}
